import {
  FETCHING_ASSET, FETCHING_ASSET_SUCCEDDED, FETCHING_ASSET_FAILED, INVALIDATE_ASSET,
  FAVORITING_ASSET_REQUEST, FAVORITING_ASSET_SUCCEDDED, FAVORITING_ASSET_FAILED,
  UNFAVORITING_ASSET_REQUEST, UNFAVORITING_ASSET_SUCCEDDED, UNFAVORITING_ASSET_FAILED,

  FETCHING_ASSET_ANALYTICS_REQUEST, FETCHING_ASSET_ANALYTICS_SUCCEDDED, FETCHING_ASSET_ANALYTICS_FAILED,

  TRACKING_ASSET_VIEW_REQUEST, TRACKING_ASSET_VIEW_SUCCEDDED, TRACKING_ASSET_VIEW_FAILED,
  DELETING_ASSET, DELETING_ASSET_SUCCEDDED, DELETING_ASSET_FAILED,

  UPLOADING_FILE_REQUEST, UPLOADING_FILE_SUCCEDDED, UPLOADING_FILE_FAILED, UPLOADING_FILE_PROGRESS,

  CREATING_ASSET_REQUEST, CREATING_ASSET_SUCCEDDED, CREATING_ASSET_FAILED,
  UPDATING_ASSET, UPDATING_ASSET_SUCCEDDED, UPDATING_ASSET_FAILED,
  UPLOAD_NEW_ASSET_VERSION_REQUEST, UPLOAD_NEW_ASSET_VERSION_SUCCEDDED, UPLOAD_NEW_ASSET_VERSION_FAILED,
  UPLOADING_NEW_ASSET_VERSION_PROGRESS, UPLOAD_NEW_ASSET_VERSION_CANCEL, TRIGGERING_ASSET_PROCESSING_REQUEST , TRIGGERING_ASSET_PROCESSING_SUCCEEDED ,
  TRIGGERING_ASSET_PROCESSING_FAILED,

  FETCHING_ASSET_PREVIEW, FETCHING_ASSET_PREVIEW_SUCCEDDED, FETCHING_ASSET_PREVIEW_FAILED,
  FETCHING_ASSET_PREVIEW_TEXT, FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED, FETCHING_ASSET_PREVIEW_TEXT_FAILED,
  FETCHING_PREVIEW_HTML_TEMPLATE, FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED, FETCHING_PREVIEW_HTML_TEMPLATE_FAILED,


  RECORDING_ASSET_SESSION_EVENT_REQUEST, RECORDING_ASSET_SESSION_EVENT_SUCCEDDED, RECORDING_ASSET_SESSION_EVENT_FAILED,
  RECORDING_ASSET_ANALYTICS_EVENT_REQUEST, RECORDING_ASSET_ANALYTICS_EVENT_SUCCEDDED, RECORDING_ASSET_ANALYTICS_EVENT_FAILED,

  CAPTURED_ASSET_VIDEO_NEW_RANGE, UPDATED_ASSET_VIDEO_RANGE, REMOVED_ASSET_VIDEO_RANGE,
  SYNCING_ASSET_VIEW_RANGE_REQUEST, SYNCING_ASSET_VIEW_RANGE_SUCCEDDED, SYNCING_ASSET_VIEW_RANGE_FAILED,
  ADD_ASSET_URL, ADD_ASSET_URL_SUCCEDDED, ADD_ASSET_URL_FAILED,

  GENERATE_ASSET_LINK_REQUEST, GENERATE_ASSET_LINK_SUCCEDDED, GENERATE_ASSET_LINK_FAILED,
  FETCHING_ASSET_LINKS_REQUEST, FETCHING_ASSET_LINKS_SUCCEDDED, FETCHING_ASSET_LINKS_FAILED,

  CLONING_ASSET_REQUEST, CLONING_ASSET_SUCCEDDED, CLONING_ASSET_FAILED,

  FETCHING_RECOMMENDED_ASSETS, FETCHING_RECOMMENDED_ASSETS_SUCCEDDED, FETCHING_RECOMMENDED_ASSETS_FAILED, INVALIDATE_RECOMMENDED_ASSETS,

  UPDATING_PAGES_TO_ASSET_REQUEST, UPDATING_PAGES_TO_ASSET_SUCCEDDED, UPDATING_PAGES_TO_ASSET_FAILED,
  INVALIDATE_MERGE_TASK,

  FETCHING_DUPLICATE_ASSET, FETCHING_DUPLICATE_ASSET_SUCCEEDED, FETCHING_DUPLICATE_ASSET_FAILED,


  CREATING_ASSET_FROM_HUB,
  CREATING_ASSET_FROM_HUB_SUCCEEDED,
  CREATING_ASSET_FROM_HUB_FAILED,

  CREATING_ASSET_ID,
  INVALIDATE_SELECTED_ASSET_ID,
  INVALIDATE_PROCESSED_ASSET_ID, FETCHING_FREQUENTLY_SHARED_ASSETS, FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED, FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED,

  FETCHING_CONTENT_RECOMMENDATIONS_REQUEST,
  FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED,
  FETCHING_CONTENT_RECOMMENDATIONS_FAILED,

  FETCHING_ASSET_SUBTITLE,
  FETCHING_ASSET_SUBTITLE_FAILED,
  FETCHING_ASSET_SUBTITLE_SUCCEDDED,

  UPDATING_ASSET_SUBTITLE,
  UPDATING_ASSET_SUBTITLE_SUCCEDDED,
  UPDATING_ASSET_SUBTITLE_FAILED,
  FETCHING_ASSET_INSIGHTS_REQUEST,
  FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED,
  FETCHING_ASSET_INSIGHTS_REQUEST_FAILED,
  FETCHING_ASSET_STORAGE_LIMIT,
  FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED,
  FETCHING_ASSET_STORAGE_LIMIT_FAILED

} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_API_URL;
const assetsApiUrl = process.env.REACT_APP_ASSETS_API_URL;

const ASSETS_API_BASE_URL = `${assetsApiUrl}/assets/3.0/`;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const ASSETS_BASE_URL = `${API_BASE_URL}/assets`;
const ANALYTICS_URL_BASE_URL = `${apiUrl}/api/2.0/analytics`;
const SEEK_BASE_URL = `${apiUrl}/api/2.0/seek`;



export function fetchAsset(id) {
  return function (dispatch) {
    dispatch(invalidateAsset());
    dispatch(fetchingAsset());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: id
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingAssetSuccedded(response.data))
      )
      .catch(error => {
        console.log(error);
        return dispatch(fetchingAssetFailed(error))
      })
  }
}

function fetchingAsset() {
  return {
    type: FETCHING_ASSET,
    payload: {}
  }
}

function fetchingAssetSuccedded(json) {
  return {
    type: FETCHING_ASSET_SUCCEDDED,
    payload: json
  }
}

function fetchingAssetFailed(error) {
  return {
    type: FETCHING_ASSET_FAILED,
    payload: error
  }
}

export function invalidateAsset() {
  return {
    type: INVALIDATE_ASSET,
    payload: {}
  }
}

/**
* Fetch fequently shared assets
*/

export function fetchFrequentlySharedAssets() {
  return function (dispatch) {
    dispatch(fetchingFrequentlySharedAssets(FETCHING_FREQUENTLY_SHARED_ASSETS));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: 'frequently-shared-assets'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingFrequentlySharedAssetsSucceeded(FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFrequentlySharedAssetsFailed(FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED, error))
      )
  }
}

function fetchingFrequentlySharedAssets(type) {
  return {
    type: type,
  }
}

function fetchingFrequentlySharedAssetsSucceeded(type, json) {
  return {
    type: type,
    payload:{
      data: json
    }
  }
}

function fetchingFrequentlySharedAssetsFailed(type, error) {
  return {
    type: type,
    payload: {
      error
    }
  }
}


export function shouldFetchAsset(state, id) {
  let resource = state.stream;

  if (!resource.item || resource.item.id != id) {
    return true
  } else if (resource.loading) {
    return false
  } else {
    return resource.invalidated
  }
}

/**
* Fetch Asset Analytics
*/
export function fetchAssetAnalytics(context) {
  return function (dispatch) {
    dispatch(fetchingAssetAnalytics(context));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: context.assetId + '/analytics'
    });

    return axios({
      method: 'GET',
      url: url
    }).then(response =>
      dispatch(fetchingAssetAnalyticsSuccedded(context, response.data))
    ).catch(error => {
      console.log(error);
      return dispatch(fetchingAssetAnalyticsFailed(context, error))
    });
  }
}

function fetchingAssetAnalytics(context) {
  return {
    type: FETCHING_ASSET_ANALYTICS_REQUEST,
    payload: context
  }
}

function fetchingAssetAnalyticsSuccedded(context, response) {
  return {
    type: FETCHING_ASSET_ANALYTICS_SUCCEDDED,
    payload: {
      context: context,
      response: response
    }
  }
}

function fetchingAssetAnalyticsFailed(context, error) {
  return {
    type: FETCHING_ASSET_ANALYTICS_FAILED,
    payload: {
      context: context,
      error: error
    }
  }
}
/*
* Adding asset to favourites
*/
export function addAssetToFavorite(asset) {
  return function (dispatch) {
    dispatch(addingAssetToFavorite());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: asset.id + '/favorites'
    });

    return axios({
      method: 'POST',
      url: url
    })
      .then(response =>
        dispatch(addingAssetToFavoriteSuccedded(asset))
      )
      .catch(error =>
        dispatch(addingAssetToFavoriteFailed(error))
      )
  }
}

function addingAssetToFavorite() {
  return {
    type: FAVORITING_ASSET_REQUEST,
    payload: {}
  }
}

function addingAssetToFavoriteSuccedded(asset) {
  return {
    type: FAVORITING_ASSET_SUCCEDDED,
    payload: asset
  }
}

function addingAssetToFavoriteFailed(error) {
  return {
    type: FAVORITING_ASSET_FAILED,
    payload: error
  }
}

/*
* Removing asset from favourites
*/
export function removeAssetFromFavorite(asset) {
  return function (dispatch) {
    dispatch(removingAssetFromFavorite());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: asset.id + '/favorites'
    });

    return axios({
      method: 'DELETE',
      url: url
    })
      .then(response =>
        dispatch(removingAssetFromFavoriteSuccedded(asset))
      )
      .catch(error =>
        dispatch(removingAssetFromFavoriteFailed(error))
      )
  }
}

function removingAssetFromFavorite() {
  return {
    type: UNFAVORITING_ASSET_REQUEST,
    payload: {}
  }
}

function removingAssetFromFavoriteSuccedded(asset) {
  return {
    type: UNFAVORITING_ASSET_SUCCEDDED,
    payload: asset
  }
}

function removingAssetFromFavoriteFailed(error) {
  return {
    type: UNFAVORITING_ASSET_FAILED,
    payload: error
  }
}

/*
* Track asset view
*/
export function trackAssetView(asset) {
  return function (dispatch) {
    dispatch(trackingAssetView());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: asset.id + '/view'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(trackingAssetViewSuccedded(response.data))
      )
      .catch(error =>
        dispatch(trackingAssetViewFailed(error))
      )
  }
}

function trackingAssetView() {
  return {
    type: TRACKING_ASSET_VIEW_REQUEST,
    payload: {}
  }
}

function trackingAssetViewSuccedded(json) {
  return {
    type: TRACKING_ASSET_VIEW_SUCCEDDED,
    payload: json
  }
}

function trackingAssetViewFailed(error) {
  return {
    type: TRACKING_ASSET_VIEW_FAILED,
    payload: error
  }
}

/*
* Create Asset from presigned s3 file
*/
export function createAsset(url, file) {
  return function (dispatch) {
    dispatch(creatingingAsset(url, file));

    var data = {
      signedUrl: url
    }

    return axios({
      method: 'POST',
      url: `${ASSETS_API_BASE_URL}/file_upload`,
      data: data
    })
      .then(response => {
        dispatch(creatingAssetSuccedded(url, file, response.data));
      }

      )
      .catch(error => {
        console.log(error);
        return dispatch(creatingAssetFailed(url, file, error));

      })
  }
}

function creatingingAsset(url, file) {
  return {
    type: CREATING_ASSET_REQUEST,
    payload: {
      file: file,
      url: url
    }
  }
}

function creatingAssetSuccedded(url, file, json) {
  return {
    type: CREATING_ASSET_SUCCEDDED,
    payload: {
      asset: json,
      file: file,
      url: url
    }
  }
}

function creatingAssetFailed(url, file, error) {
  return {
    type: CREATING_ASSET_FAILED,
    payload: {
      error: error,
      url: url,
      file: file
    }
  }
}

/*
* Create Asset from url
*/
export function createAssetFromUrl(request) {
   return function (dispatch) {
    dispatch(creatingAssetFromUrl(_.get(request,"url")));

    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/url`,
      data: request
    })
      .then(response => {
        return dispatch(creatingAssetFromUrlSuccedded(_.get(request,"url"), response.data))
      })
      .catch(error => {
        return dispatch(creatingAssetFromUrlFailed(_.get(request,"url"), error))
      })
  }
}

function creatingAssetFromUrl(url) {
  return {
    type: ADD_ASSET_URL,
    payload: {
      url: url
    }
  }
}

function creatingAssetFromUrlSuccedded(url, json) {
  return {
    type: ADD_ASSET_URL_SUCCEDDED,
    payload: {
      asset: json,
      url: url
    }
  }
}

function creatingAssetFromUrlFailed(url, error) {
  return {
    type: ADD_ASSET_URL_FAILED,
    payload: {
      error: error,
      url: url
    }
  }
}

// Track file upload to s3
export function uploadingFile(file) {
  return {
    type: UPLOADING_FILE_REQUEST,
    payload: {
      file: file
    }
  }
}

export function uploadingFileFailed(file) {
  return {
    type: UPLOADING_FILE_FAILED,
    payload: {
      file: file
    }
  }
}

export function uploadingFileProgress(file, progress) {
  return {
    type: UPLOADING_FILE_PROGRESS,
    payload: {
      progress: progress,
      file: file
    }
  }
}

/*
* Delete Asset
*/
export function deleteAsset(asset, streamId, groupId) {
  return function (dispatch) {
    dispatch(deletingAsset(streamId, groupId));

    return axios({
      method: 'DELETE',
      url: `${ASSETS_BASE_URL}/${asset.id}`
    })
      .then(response => {
        return dispatch(deletingAssetSuccedded(asset, streamId, groupId))
      })
      .catch(error => {
        return dispatch(deletingAssetFailed(error, streamId, groupId))
      })
  }
}

function deletingAsset(streamId, groupId) {
  return {
    type: DELETING_ASSET,
    payload: {
      streamId: streamId,
      groupId: groupId
    }
  }
}

function deletingAssetSuccedded(json, streamId, groupId) {
  return {
    type: DELETING_ASSET_SUCCEDDED,
    payload: {
      asset: json,
      streamId: streamId,
      groupId: groupId
    }
  }
}

function deletingAssetFailed(error, streamId, groupId) {
  return {
    type: DELETING_ASSET_FAILED,
    payload: {
      error: error,
      streamId: streamId,
      groupId: groupId
    }
  }
}

/*
* Update Asset
*/
export function updateAsset(asset, streamId, parentId) {
  return function (dispatch) {
    dispatch(updatingAsset(asset.id, streamId, parentId));

    return axios({
      method: 'PUT',
      url: `${ASSETS_BASE_URL}/${asset.id}`,
      data: asset
    })
      .then(response => {
        return dispatch(updatingAssetSuccedded(response.data, streamId, parentId))
      })
      .catch(error => {
        console.log(error);
        return dispatch(updatingAssetFailed(error, streamId, parentId))
      })
  }
}

function updatingAsset(assetId, parentId, streamId) {
  return {
    type: UPDATING_ASSET,
    payload: {
      assetId: assetId,
      streamId, streamId,
      parentId: parentId
    }
  }
}

function updatingAssetSuccedded(json, streamId, parentId) {
  return {
    type: UPDATING_ASSET_SUCCEDDED,
    payload: {
      asset: json,
      streamId, streamId,
      parentId: parentId
    }
  }
}

function updatingAssetFailed(error, streamId, parentId) {
  return {
    type: UPDATING_ASSET_FAILED,
    payload: {
      error: error,
      streamId, streamId,
      parentId: parentId
    }
  }
}

/*
*Fetch Asset Subtitle
*/

export function fetchAssetSubtitles(id) {
  return function (dispatch) {
    dispatch(fetchingAssetSubtitles());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/subtitle`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingAssetSubtitlesSuccedded(response.data))
      )
      .catch(error => {
        return dispatch(fetchingAssetSubtitlesFailed(error))
      })
  }
}

function fetchingAssetSubtitles() {
  return {
    type: FETCHING_ASSET_SUBTITLE,
  }
}

function fetchingAssetSubtitlesSuccedded(response) {
  return {
    type: FETCHING_ASSET_SUBTITLE_SUCCEDDED,
    payload: response
  }
}

function fetchingAssetSubtitlesFailed(error) {
  return {
    type: FETCHING_ASSET_SUBTITLE_FAILED,
    payload: error
  }
}

/*
* Update Asset subtitles
*/

export function updateSubtitles(id, data) {
  return function (dispatch) {
    dispatch(updateSubtitlesRequest());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/subtitle`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: data
    }).then(response => 
      dispatch(updatingSubtitlesSucceeded(response.data))
      ).catch(error => {
        return dispatch(updatingSubtitlesFailed(error))
      })
  }
}

function updateSubtitlesRequest() {
  return {
    type: UPDATING_ASSET_SUBTITLE
  }

}

function updatingSubtitlesSucceeded(response) {
  return{
    type: UPDATING_ASSET_SUBTITLE_SUCCEDDED,
    payload: response
  }

}

function updatingSubtitlesFailed(error) {
  return {
    type: UPDATING_ASSET_SUBTITLE_FAILED,
    payload: error
  }

}



/*
* Upload New Asset Version
*/
export function uploadNewVersion(id, signedUrl, file) {
  return function (dispatch) {

    var data = {
      signedUrl: signedUrl
    }

    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/${id}/version`,
      data: data
    })
      .then(response => {
        return dispatch(uploadingNewVersionSuccedded(response.data))
      })
      .catch(error => {
        return dispatch(uploadingNewVersionFailed(error))
      })
  }
}

export function uploadingNewVersion(file) {
  return {
    type: UPLOAD_NEW_ASSET_VERSION_REQUEST,
    payload: {
      file: file
    }
  }
}

export function uploadingNewVersionSuccedded(json) {
  return {
    type: UPLOAD_NEW_ASSET_VERSION_SUCCEDDED,
    payload: json
  }
}

export function uploadingNewVersionFailed(error) {
  return {
    type: UPLOAD_NEW_ASSET_VERSION_FAILED,
    payload: error
  }
}

export function cancelNewVersionUpload(file) {
  return {
    type: UPLOAD_NEW_ASSET_VERSION_CANCEL,
    payload: file
  }
}

export function uploadingNewVersionProgress(progress) {
  return {
    type: UPLOADING_NEW_ASSET_VERSION_PROGRESS,
    payload: {
      progress: progress
    }
  }
}

/*
* Fetch the asset preview Images
*/
export function fetchPreviewAsset(id) {
  return function (dispatch) {
    dispatch(fetchingPreviewAsset(id));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/preview`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingPreviewAssetSuccedded(id, response.data))
      )
      .catch(error => {
        console.log(error);
        return dispatch(fetchingPreviewAssetFailed(id, error))
      })
  }
}

function fetchingPreviewAsset(id) {
  return {
    type: FETCHING_ASSET_PREVIEW,
    payload: { id }
  }
}

function fetchingPreviewAssetSuccedded(id, json) {
  return {
    type: FETCHING_ASSET_PREVIEW_SUCCEDDED,
    payload: {
      id: id,
      result: json
    }
  }
}

function fetchingPreviewAssetFailed(id, error) {
  return {
    type: FETCHING_ASSET_PREVIEW_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/*
* Fetch the asset preview Text
*/
export function fetchPreviewTextLayer(id) {
  return function (dispatch) {
    dispatch(fetchingPreviewTextLayer());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/preview/text`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingPreviewTextLayerSuccedded(response.data))
      )
      .catch(error => {
        console.log(error);
        return dispatch(fetchingPreviewTextLayerFailed(error))
      })
  }
}

function fetchingPreviewTextLayer() {
  return {
    type: FETCHING_ASSET_PREVIEW_TEXT,
    payload: {}
  }
}

function fetchingPreviewTextLayerSuccedded(json) {
  return {
    type: FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED,
    payload: json
  }
}

function fetchingPreviewTextLayerFailed(error) {
  return {
    type: FETCHING_ASSET_PREVIEW_TEXT_FAILED,
    payload: error
  }
}


/*
* Fetch the asset preview html template
*/
export function fetchPreviewHtmlTemplate(url) {
  return function (dispatch) {
    dispatch(fetchPreviewHtmlTemplateRequest(url));

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingPreviewHtmlTemplateSucceeded(response.data))
      )
      .catch(error =>
        dispatch(fetchingPreviewHtmlTemplateFailed(error))
      )
  }

  function fetchPreviewHtmlTemplateRequest(url) {
    return {
      type: FETCHING_PREVIEW_HTML_TEMPLATE,
      payload: {
        url: url
      }
    }
  }

  function fetchingPreviewHtmlTemplateSucceeded(json) {
    return {
      type: FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED,
      payload: {
        html: json
      }
    }
  }

  function fetchingPreviewHtmlTemplateFailed(error) {
    console.log(error);
    return {
      type: FETCHING_PREVIEW_HTML_TEMPLATE_FAILED,
      payload: {
        error: error
      }
    }
  }
}


/**
* Start asset view session
*/
export function recordSessionAnalyticsEvent(event) {
  return function (dispatch) {
    dispatch(recordingSessionAnalyticsEvent());

    return axios({
      method: 'POST',
      url: ANALYTICS_URL_BASE_URL,
      data: event
    })
      .then(response =>
        dispatch(recordingSessionAnalyticsEventSuccedded(response.data))
      )
      .catch(error =>
        dispatch(recordingSessionAnalyticsEventFailed(error))
      )
  }
}

function recordingSessionAnalyticsEvent() {
  return {
    type: RECORDING_ASSET_SESSION_EVENT_REQUEST,
    payload: {}
  }
}

function recordingSessionAnalyticsEventSuccedded(json) {
  return {
    type: RECORDING_ASSET_SESSION_EVENT_SUCCEDDED,
    payload: json
  }
}

function recordingSessionAnalyticsEventFailed(error) {
  console.log(error);
  return {
    type: RECORDING_ASSET_SESSION_EVENT_FAILED,
    payload: error
  }
}

/**
* Create an analytics event
*/
export function recordAnalyticsEvent(event) {
  return function (dispatch) {
    dispatch(recordingAnalyticsEvent());

    return axios({
      method: 'POST',
      url: ANALYTICS_URL_BASE_URL,
      data: event
    })
      .then(response =>
        dispatch(recordingAnalyticsEventSuccedded(response.data))
      )
      .catch(error =>
        dispatch(recordingAnalyticsEventFailed(error))
      )
  }
}

function recordingAnalyticsEvent() {
  return {
    type: RECORDING_ASSET_ANALYTICS_EVENT_REQUEST,
    payload: {}
  }
}

function recordingAnalyticsEventSuccedded(json) {
  return {
    type: RECORDING_ASSET_ANALYTICS_EVENT_SUCCEDDED,
    payload: json
  }
}

function recordingAnalyticsEventFailed(error) {
  console.log(error);
  return {
    type: RECORDING_ASSET_ANALYTICS_EVENT_FAILED,
    payload: error
  }
}

/**
* -----------------------------------------------------
*   Video Analytics
*   - Capture viewing new range in video, returns an
*     internal id
* -----------------------------------------------------
*/

export function captureNewVideoRange(startRange) {
  return function (dispatch) {
    var id = '_' + Math.random().toString(36).substr(2, 9);

    dispatch({
      type: CAPTURED_ASSET_VIDEO_NEW_RANGE,
      payload: {
        id: id,
        external_id: null,
        start: startRange,
        end: startRange,
        synced: false,
        syncing: false,
        updatedDate: new Date().getTime(),
        syncedDate: null
      }
    });

    return id;
  }
}

/**
* -----------------------------------------------------
*   Video Analytics
*   - update range in video
* -----------------------------------------------------
*/

export function updateVideoRange(id, endRange) {
  return {
    type: UPDATED_ASSET_VIDEO_RANGE,
    payload: {
      id: id,
      end: endRange,
      updatedDate: new Date().getTime()
    }
  }
}

/**
* -----------------------------------------------------
*   Video Analytics
*   - remove video range after sync
* -----------------------------------------------------
*/

export function removeVideoRange(id) {
  return {
    type: REMOVED_ASSET_VIDEO_RANGE,
    payload: {
      id: id
    }
  }
}

/**
* -----------------------------------------------------
*   Video Analytics
*   - Sync range with the server
* -----------------------------------------------------
*/

export function syncAssetVideoRange(rangeID, event) {
  return function (dispatch) {
    dispatch(syncingAssetVideoRange(rangeID, event));

    return axios({
      method: 'POST',
      url: ANALYTICS_URL_BASE_URL,
      data: event
    })
      .then(response =>
        dispatch(syncingAssetVideoRangeSuccedded(rangeID, response.data))
      )
      .catch(error =>
        dispatch(syncingAssetVideoRangeFailed(rangeID, error))
      )
  }
}

function syncingAssetVideoRange(id, event) {
  return {
    type: SYNCING_ASSET_VIEW_RANGE_REQUEST,
    payload: {
      id: id
    }
  }
}

function syncingAssetVideoRangeSuccedded(id, response) {
  return {
    type: SYNCING_ASSET_VIEW_RANGE_SUCCEDDED,
    payload: {
      id: id,
      range: response
    }
  }
}

function syncingAssetVideoRangeFailed(id, error) {
  console.log(error);
  return {
    type: SYNCING_ASSET_VIEW_RANGE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}


/**
* Generate Customer Tracking link
*/
export function generateAssetLink(asset, createLink) {
  return function (dispatch) {
    dispatch(generatingAssetLink(createLink));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${asset.id}/link`
    });
    return axios({
      method: 'POST',
      url: url,
      data: createLink
    })
      .then(response =>
        dispatch(generatingAssetLinkSuccedded(response.data, createLink))
      )
      .catch(error =>
        dispatch(generatingAssetLinkFailed(error))
      )
  }
}

function generatingAssetLink(createLink) {
  return {
    type: GENERATE_ASSET_LINK_REQUEST,
    payload: createLink
  }
}

function generatingAssetLinkSuccedded(json, createLink) {
  return {
    type: GENERATE_ASSET_LINK_SUCCEDDED,
    payload: json
  }
}

function generatingAssetLinkFailed(error) {
  console.log(error);

  return {
    type: GENERATE_ASSET_LINK_FAILED,
    payload: error
  }
}

/**
* Fetch links for asset
*/
export function fetchLinksForAsset(id, page) {
  return function (dispatch) {
    dispatch(fetchingLinksForAssetRequest(id));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/links`,
      queryParams: {
        page: page
      }
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingLinksForAssetSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(fetchingLinksForAssetFailed(id, error))
      )
  }
}

function fetchingLinksForAssetRequest(id) {
  return {
    type: FETCHING_ASSET_LINKS_REQUEST,
    payload: id
  }
}

function fetchingLinksForAssetSuccedded(id, json) {
  return {
    type: FETCHING_ASSET_LINKS_SUCCEDDED,
    payload: {
      id: id,
      links: json
    }
  }
}

function fetchingLinksForAssetFailed(id, error) {
  return {
    type: FETCHING_ASSET_LINKS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
* clone Asset
*/
export function cloneAsset(asset, destination) {
  return function (dispatch) {
    dispatch(fetchingAction("CLONING_ASSET_REQUEST"));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${asset.id}/clone`,
    });

    return axios({
      method: 'POST',
      url: url,
      data: destination
    })
      .then(response =>
        dispatch(fetchingSucceededAction("CLONING_ASSET_SUCCEDDED", response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction("CLONING_ASSET_FAILED", error))
      )
  }
}

export function shouldFetchResource(resource) {
  if (!resource) {
    return true
  } else if (resource.loading) {
    return false
  } else {
    return resource.invalidated
  }
}

/*
* Fetching Recommended Assets
*/

export function fetchRecommendedAssets(id) {
  return function (dispatch) {
    dispatch(fetchingRecommendedAssets());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/recommendations`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingRecommendedAssetsSuccedded(response.data))
      )
      .catch(error => {
        console.log(error);
        return dispatch(fetchingRecommendedAssetsFailed(error))
      })
  }
}

function fetchingRecommendedAssets() {
  return {
    type: FETCHING_RECOMMENDED_ASSETS,
    payload: {}
  }
}

function fetchingRecommendedAssetsSuccedded(json) {
  return {
    type: FETCHING_RECOMMENDED_ASSETS_SUCCEDDED,
    payload: json
  }
}

function fetchingRecommendedAssetsFailed(error) {
  return {
    type: FETCHING_RECOMMENDED_ASSETS_FAILED,
    payload: error
  }
}

export function invalidateRecommendedAssets() {
  return {
    type: INVALIDATE_RECOMMENDED_ASSETS,
    payload: {}
  }
}

export function updatePagesToAsset(id, pages, assetType) {
  return function (dispatch) {
    dispatch(updatingPagesToAsset());

    return axios({
      method: 'PUT',
      url: `${ASSETS_BASE_URL}/${id}/pages/merge/${assetType}`,
      data: pages
    })
      .then(response => {
        return dispatch(updatingPagesToAssetSuccedded(response.data))
      })
      .catch(error => {
        return dispatch(updatingPagesToAssetFailed(error))
      })
  }
}
function updatingPagesToAsset() {
  return {
    type: UPDATING_PAGES_TO_ASSET_REQUEST,
    payload: {}
  }
}

function updatingPagesToAssetSuccedded(json) {
  return {
    type: UPDATING_PAGES_TO_ASSET_SUCCEDDED,
    payload: json
  }
}

function updatingPagesToAssetFailed(error) {
  return {
    type: UPDATING_PAGES_TO_ASSET_FAILED,
    payload: error
  }
}

export function invalidateMergeTask() {
  return {
    type: INVALIDATE_MERGE_TASK,
    payload: {}
  }
}



/*
  Fetching most similar asset
*/

export function fetchDuplicateAsset(request) {
  return function (dispatch) {
    dispatch(fetchingDuplicateAsset(request.asset));

    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/duplicate-assets`,
      data: request
    })
      .then(response =>
        dispatch(fetchingDuplicateAssetSucceeded(response.data))
      )
      .catch(error =>
        dispatch(fetchingDuplicateAssetFailed(request.asset, error))
      )
  }
}

function fetchingDuplicateAsset(id) {
  return {
    type: FETCHING_DUPLICATE_ASSET,
    payload: { id }
  }
}

function fetchingDuplicateAssetSucceeded(asset) {
  return {
    type: FETCHING_DUPLICATE_ASSET_SUCCEEDED,
    payload: asset
  }
}

function fetchingDuplicateAssetFailed(id, error) {
  return {
    type: FETCHING_DUPLICATE_ASSET_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}



export function createAssetFromHub(request, type) {
  return function (dispatch) {
    dispatch(creatingAssetFromHub(request));


    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/create-asset/${type}`,
      data: request
    })
      .then(response => {
        return dispatch(creatingAssetFromHubSucceeded(response.data));

      })
      .catch((id, error) => {
        return dispatch(creatingAssetFromHubFailed(id, error))
      })

  }
}

function creatingAssetFromHub(request) {
  return {
    type: CREATING_ASSET_FROM_HUB,
    payload: request
  }

}

function creatingAssetFromHubSucceeded(response) {
  return {
    type: CREATING_ASSET_FROM_HUB_SUCCEEDED,
    payload: response
  }

}

function creatingAssetFromHubFailed(id, error) {
  return {
    type: CREATING_ASSET_FROM_HUB_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

export function createAssetId(id, processing) {
  return {
    type: CREATING_ASSET_ID,
    payload: {
      id: id,
      processing: processing
    }
  }
}

export function invalidateSelectedAssetId() {
  return {
    type: INVALIDATE_SELECTED_ASSET_ID
  }
}

export function invalidateProcessedAssetId() {
  return {
    type: INVALIDATE_PROCESSED_ASSET_ID
  }
}


/*
* Fetching Compose Recommended Assets
*/

export function fetchContentRecommendations(selectedAssets) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_CONTENT_RECOMMENDATIONS_REQUEST));
    
    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/content-recommendations`,
      data: selectedAssets
    })
      .then(response => {
        return dispatch(fetchingSucceededAction(FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED, response.data));

      })
      .catch(error => {
        return dispatch(fetchingFailedAction(FETCHING_CONTENT_RECOMMENDATIONS_FAILED, error))
      })

  }
}

/*
* Common functions
*/
function fetchingAction(type) {
  return {
    type: type,
    payload: {}
  }
}

function fetchingSucceededAction(type, json) {
  return {
    type: type,
    payload: json
  }
}

function fetchingFailedAction(type, error) {
  return {
    type: type,
    payload: error
  }
}

//fetch asset insights
export function fetchAssetInsights(assetId){
  return function(dispatch){
    dispatch(fetchingAssetInsightsRequest());


    let url = buildUrl(SEEK_BASE_URL, {
      path: `/asset/${assetId}/insights`,
    });
    return axios({
      method: "GET",
      url: url
    })

    .then(response =>
      dispatch(fetchingAssetInsightsSuccedded(response.data))
    )
    .catch(error => {
      console.log(error);
      return dispatch(fetchingAssetInsightsFailed(error))
    })
  }
}

function fetchingAssetInsightsRequest(){
  return {
    type: FETCHING_ASSET_INSIGHTS_REQUEST,
    payload: {}
  }
}

function fetchingAssetInsightsSuccedded(json){
  return {
    type: FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED,
    payload: json
  }
}

function fetchingAssetInsightsFailed(error){
  return {
    type: FETCHING_ASSET_INSIGHTS_REQUEST_FAILED,
    payload: error
  }
}

// fetch asset storage limit

export function fetchAssetStorageLimit(){
  return function(dispatch){
    dispatch(fetchingAssetStorageLimitRequest());


    let url = buildUrl(ASSETS_BASE_URL, {
      path: `storage-limit`,
    });
    return axios({
      method: "GET",
      url: url
    })

    .then(response =>
      dispatch(fetchingAssetStorageLimitSuccedded(response.data))
    )
    .catch(error => {
      return dispatch(fetchingAssetStorageLimitFailed(error))
    })
  }
}

function fetchingAssetStorageLimitRequest(){
  return {
    type: FETCHING_ASSET_STORAGE_LIMIT,
    payload: {}
  }
}

function fetchingAssetStorageLimitSuccedded(json){
  return {
    type: FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED,
    payload: json
  }
}

function fetchingAssetStorageLimitFailed(error){
  return {
    type: FETCHING_ASSET_STORAGE_LIMIT_FAILED,
    payload: error
  }
}

//Trigger the Asset Processing 

export function triggerAssetProcessing(id) {
  return function (dispatch) {

    dispatch(triggeringAssetProcessingRequest(id));


    return axios({
      method: 'POST',
      url: `${ASSETS_BASE_URL}/${id}/process`,

    })
      .then(response => {
        return dispatch(triggeringAssetProcessingSucceeded(response.data)) 
      })
      .catch(error => {
        return dispatch(triggeringAssetProcessingFailed(error))
      })
  }
}

function triggeringAssetProcessingRequest(id) {
  return {
    type: TRIGGERING_ASSET_PROCESSING_REQUEST,
    payload: {
      id:id
      }
  }
}

function triggeringAssetProcessingSucceeded(data) {
  return {
    type: TRIGGERING_ASSET_PROCESSING_SUCCEEDED,
    payload: data
  }
}

function triggeringAssetProcessingFailed(error) {
  return {
    type: TRIGGERING_ASSET_PROCESSING_FAILED,
    payload: error
  }
}
